// extracted by mini-css-extract-plugin
export default {"c-select":"select_c-select__xSDYG"};